import React from "react";
import { Button, Text, Card, CardContent } from "./index";
import { Icon } from "./Icon";

export interface EmptyStateProps {
  icon: string;
  title: string;
  description: string;
  actionLabel: string;
  actionLabelIcon?: string;
  onAction?: () => void;
  className?: string;
}

export const EmptyState = React.forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ icon, title, description, actionLabel, actionLabelIcon, onAction, className }, ref) => {
    return (
      <Card
        className={className}
        ref={ref}
      >
        <CardContent className="flex flex-col items-center justify-center !py-12">
          <div className="w-24 h-24 mb-6 flex items-center justify-center rounded-full bg-brand/10 dark:bg-brand/20">
            <Icon
              name={icon}
              size={48}
              className="text-brand dark:text-brand-light"
            />
          </div>
          <Text className="text-lg font-medium text-gray-900 dark:text-white mb-2">{title}</Text>
          <Text className="text-gray-600 dark:text-gray-400 text-center max-w-md mb-6">{description}</Text>
          <Button
            variant="outline"
            onClick={onAction}
          >
            <Icon
              name={actionLabelIcon || "add"}
              size={16}
              className="mr-2"
            />
            {actionLabel}
          </Button>
        </CardContent>
      </Card>
    );
  },
);

EmptyState.displayName = "EmptyState";
